// A visit can carry multiple disciplines; the calendar keys its color and glyph off the
// first (primary) one. Centralized so that assumption lives in one place if it ever changes.
export const primaryDisciplineCode = (
    disciplines: readonly { code: string }[],
): string | undefined => disciplines[0]?.code;
